export default {
  sections: {
    coreOverview: 'Core Metrics Overview',
    uvpv: 'UV/PV Trend Analysis',
    stayTime: 'Page Dwell Time Trend',
    bounceRate: 'Bounce Rate Trend',
    registeredUsers: 'Registered Users Trend',
    activeUsers: 'Active Users Trend',
    certifiedCompanies: 'Certified Companies Trend',
    portHeat: 'Port Popularity Ranking TOP20',
    portFailure: 'Port Combination Failure Ranking TOP20',
    inquiryCount: 'Inquiry Volume Statistics',
    inquiryPort: 'Port Combination Inquiry Ranking TOP20',
    inquiryCustomer: 'Customer Inquiry Ranking TOP20',
    quoteCount: 'Quotation Volume Statistics',
    quotePort: 'Port Combination Quotation Ranking TOP20',
    quoter: 'Quoter Ranking TOP20',
    quoteTimeliness: 'Quotation Timeliness Statistics',
    quoteEfficiency: 'Quotation Efficiency Ranking TOP20',
    overtimeQuotes: 'Overdue Unquoted List',
    rateMaintenance: 'Rate Maintenance Volume Statistics',
    rateStatus: 'Rate Status Distribution',
    rateAvgTrend: 'Average Rate Trend Statistics',
    businessDataDashboard: 'Business Data Dashboard'
  },

  filters: {
    timeRange: 'Time Range',
    page: 'Page',
    userType: 'User Type',
    certStatus: 'Certification Status',
    dataScope: 'Data Scope',
    source: 'Source',
    originPort: 'Origin Port',
    destPort: 'Destination Port',
    timeoutHours: 'Timeout (h)',
    carrier: 'Carrier',
    containerSelection: 'Container Type:',
    rateType: 'Rate Type',
    selectContainers: 'Select Container Type',
    selectRateTypes: 'Select Rate Type',
    selectAll: 'Select All',
    timeDimension: 'Time Dimension',
    route: 'Route',
    salesperson: 'Salesperson',
    containerType: 'Container Type'
  },

  options: {
    all: 'All',
    individual: 'Individual',
    joinedCompany: 'Joined Company',
    pending: 'Pending',
    rejected: 'Rejected',
    approved: 'Approved',
    internal: 'Internal',
    external: 'External',
    group: 'Group',
    company: 'Company',
    department: 'Department',
    personal: 'Personal'
  },

  rateTypes: {
    fclRates: 'FCL Rates',
    precarriageRates: 'PreCarriage Rates',
    lastMileRates: 'Last Mile Rates'
  },

  charts: {
    uvpv: {
      legendUV: 'UV (Unique Visitors)',
      legendPV: 'PV (Page Views)'
    },
    common: {
      emptyValue: 'No Data'
    }
  },

  units: {
    seconds: 's'
  },

  pages: {
    all: 'All Pages',
    home: 'Home',
    biAnalyticsPage: 'BI Analytics',
    dashboard: 'Dashboard',
    controlTowerPanel: 'Control Tower Panel',
    saasRateManagement: 'Rate Maintenance',
    saasContractManagement: 'Contract Management',
    saasSurchargeManagement: 'Surcharge Maintenance',
    saasIncreaseRules: 'Increase Rules Maintenance',
    saasRateQuery: 'Rate Query',
    saasInquiryManagement: 'Inquiry Management',
    saasQuotationManagement: 'Quotation Management',
    ordersManagement: 'Order Management',
    shippingLineMaintenance: 'Route Maintenance',
    shippingScheduleQuery: 'Schedule Query',
    customerUserManagement: 'User Management',
    customerCompanyManagement: 'Company Management',
    customerRoleAuthManagement: 'Role & Permission Management',
    userCenter: 'User Center',
    applicationCenter: 'Application Center',
    apiCenter: 'API Center',
    systemSettings: 'System Settings',
    basicData: 'Basic Data Maintenance',
    salesMarketingLeads: 'Marketing Leads',
    salesAiCustomerAcquisition: 'AI Customer Acquisition'
  },

  cards: {
    uv: {
      title: 'UV (Unique Visitors)',
      desc: 'Total UV'
    },
    pv: {
      title: 'PV (Page Views)',
      desc: 'Total PV'
    },
    stayTime: {
      title: 'Average Dwell Time',
      desc: 'Average dwell time (seconds)'
    },
    bounceRate: {
      title: 'Bounce Rate',
      desc: 'Page bounce rate'
    }
  },

  labels: {
    registeredUsers: 'Registered Users',
    activeUsers: 'Active Users',
    certifiedCompanies: 'Certified Companies',
    inquiryCount: 'Inquiry Volume',
    quoteCount: 'Quotation Volume',
    rateMaintenance: 'Rate Maintenance Volume',
    rateStatus: 'Rate Status',
    avgTimeliness: 'Average Timeliness',
    avgDuration: 'Average Duration',
    searchCount: 'Search Count',
    failureCount: 'Failure Count',
    price: 'price(USD)'
  },

  axis: {
    orders: '{value}',
    people: '{value}',
    companies: '{value}',
    times: '{value}',
    percent: '{value}%',
    seconds: '{value}s',
    hours: '{value}h'
  },

  rateStatusNames: {
    pending: 'Pending',
    active: 'Active',
    expired: 'Expired',
    offline: 'Offline'
  },

  overtimeQuotes: {
    columns: {
      inquiryNo: 'Inquiry No.',
      client: 'Customer',
      portCombo: 'Port Combination',
      submitTime: 'Submitted At',
      overtimeHours: 'Overtime (hours)'
    }
  },

  businessDashboard: {
    title: 'Business Data Dashboard',
    exportData: 'Export Data',
    refresh: 'Refresh',
    resetConditions: 'Reset',
    queryData: 'Query',
    kpi: {
      inquiryVolume: 'Inquiry Vol',
      quotationVolume: 'Quotation Vol',
      bookingVolume: 'Booking Vol',
      bookingRate: 'Booking Rate',
      cancellationVolume: 'Cancellation Vol',
      cancellationRate: 'Cancellation Rate',
      comparedToLastDay: 'vs Yesterday',
      comparedToLastWeek: 'vs Last Week',
      comparedToLastMonth: 'vs Last Month',
      comparedToLastQuarter: 'vs Last Quarter',
      comparedToLastYear: 'vs Last Year'
    },
    table: {
      title: 'Route Volume Statistics',
      routeName: 'Route Name',
      routePath: 'Route Path',
      inquiryVolume: 'Inquiry Vol',
      quotationVolume: 'Quotation Vol',
      bookingVolumeTeu: 'Booking Vol',
      bookingRate: 'Booking Rate',
      cancellationVolumeTeu: 'Cancellation(TEU)',
      cancellationRate: 'Cancellation Rate',
      operation: 'Operation',
      details: 'Details'
    },
    timeDimensions: {
      range: 'Range',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      yearly: 'Yearly'
    }
  },
  config: {
    title: 'Panel Configuration',
    tips: 'Drag cards to adjust display order, use switches to control visibility',
    show: 'Show',
    hide: 'Hide',
    save: 'Save',
    reset: 'Reset',
    cancel: 'Cancel',
    saveSuccess: 'Configuration saved successfully',
    saveFailed: 'Failed to save configuration',
    resetSuccess: 'Reset to default configuration'
  },
  messages: {
    calcDateRange: 'Calculate date range',
    loadKpiFailed: 'Failed to load KPI data',
    loadRouteStatFailed: 'Failed to load route statistics',
    requestParams: 'Request parameters',
    interfaceResponse: 'Interface response',
    rawResponse: 'Raw response',
    invalidFormat: 'Invalid data format from interface',
    updateSuccess: 'Table data updated',
    totalCount: 'Total count',
    currentPage: 'Current page',
    loadConfigFailed: 'Failed to load card configuration',
    fetchStatFailed: 'Failed to fetch statistical range data',
    normDateRangeFailed: 'Failed to normalize date range'
  }
}

